export { PhoneNumberMaskInput } from './phone-number-masked-input';
export { EmailInput } from './email-masked-input';
export { NameInput } from './name-input';

export type MaskInputProps = {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
};
